import React from "react"
import styled from "styled-components"
import Swiper from "react-id-swiper/lib/ReactIdSwiper.full"
import Frank from "~/public/static/images/svg/Frank.svg"
import Nathan from "~/public/static/images/svg/Nathan.svg"
import Alteb from "~/public/static/images/svg/Alteb.svg"

const Window = styled.div`
  position: relative;
  border-radius: 10px;
  height: 100px;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  width: 100%;
`

const WinnerText = styled.div`
  user-select: none;
  margin-left: 10px;
`

const RecentWinnerCard = styled.div`
  background: #ffffff;
  border-radius: 10px;
  display: flex;
  margin: 0 15px;
  padding: 10px;
  justify-content: center;
  margin-bottom: 20px;
  box-shadow: 0px 3px 7px rgba(35, 41, 48, 0.2);
  align-items: center;
`

const RecentWinnerAvatar = styled.img`
  border-radius: 50%;
  width: 50px;
`

const recentWinners = [
  {
    name: "Frank",
    gender: "male",
    avatar: Frank,
    points: 2,
  },
  {
    name: "Nathan",
    gender: "male",
    avatar: Nathan,
    points: 5,
  },
  {
    name: "Alteb",
    gender: "male",
    avatar: Alteb,
    points: 8,
  },
]

const SlickSlider = () => {
  const settings = {
    rebuildOnUpdate: true,
    initialSlide: 1,
    centeredSlides: true,
    preventInteractionOnTransition: true,
    grabCursor: true,
    loop: true,
    roundLengths: true,
    watchOverflow: true,
    slidesPerView: 3,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
  }
  return (
    <Window>
      <Swiper {...settings}>
        {recentWinners.map((winner) => (
          <div data-history={winner.objectId} key={winner.name}>
            <RecentWinnerCard>
              <RecentWinnerAvatar
                src={winner.avatar}
                alt={`${winner.name} - Recent Winner`}
              />
              <WinnerText>
                {winner.name} saved&nbsp;
                <strong>
                  {winner.points} point{winner.points > 1 ? "s " : " "}
                </strong>
                on {winner.gender === "male" ? "his" : "her"} license.
              </WinnerText>
            </RecentWinnerCard>
          </div>
        ))}
      </Swiper>
    </Window>
  )
}

export default SlickSlider
